import React, { useRef, useState } from "react";
import cx from "classnames";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "../input/InputErrorList";
import { Checkbox } from "./Checkbox";
import { Typography, typographyTextToProps, } from "../typography/Typography";
import "./CheckboxGroup.scss";
function alternativeInValues(alternative, values) {
    return typeof values.find((val) => compare(val, alternative)) !== "undefined";
}
function compare(a, b) {
    return (a.text === b.text && JSON.stringify(a.value) === JSON.stringify(b.value));
}
export const CheckboxGroup = ({ alternatives, header, headerType = "small", onChange, validators = [], forceValidation = false, values = [], "data-test-id": dataTestId, }) => {
    const [inputName] = useState("checkbox_group_" + Math.random().toString(36).substring(2, 11));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(values, validators, forceValidation);
    useForm(inputName, validity, values, resetValidation, containerRef, errorMessages, header);
    const internalOnChange = (alternative) => {
        let value;
        if (values.find((val) => compare(val, alternative))) {
            value = values.filter((value) => !compare(value, alternative));
        }
        else {
            value = [...values, alternative];
        }
        onChange(value);
    };
    return (React.createElement("fieldset", { ref: containerRef, className: cx("lysa-ui-checkbox-group", validityClasses), "data-test-id": dataTestId },
        React.createElement(Typography, Object.assign({ type: headerType === "small" ? "body" : "h3" }, typographyTextToProps(header), { component: "legend" })),
        alternatives.map((alternative) => (React.createElement(Checkbox, { key: "key_" + alternative.value, alternative: alternative, checked: alternativeInValues(alternative, values), onChange: internalOnChange, "data-test-id-partial": dataTestId }))),
        React.createElement(InputErrorList, { errorMessages: errorMessages })));
};
